<td>
  @for (tag of tags; track tag) {
    <p>{{tag.name}}</p>
  }
</td>